import React, { useEffect, useState } from 'react';

const Loader = ({useLoader}) => {
  return (
    <>
  {useLoader && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-[9998]"
    style={{ pointerEvents: "auto" }}
  >
    <div
      className="rounded-full animate-spin z-[999999]"
      style={{
        width: 30,
        height: 30,
        borderWidth: 4,
        borderStyle: "solid",
        borderColor: "#10b981",
        borderTopColor: "transparent",
      }}
    ></div>
  </div>
)}

    </>
  );
};

export default Loader;
